export default __webpack_public_path__ + "static/media/NRExplorer300.158a58fe.jpg";